import { render, staticRenderFns } from "./CantCreateMoreObjective.vue?vue&type=template&id=2409cfbc&"
import script from "./CantCreateMoreObjective.vue?vue&type=script&lang=js&"
export * from "./CantCreateMoreObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports